import gql from 'graphql-tag';

export const add = gql`mutation CreateUnderwriterRate($underwriterRate: UnderwriterRateInput!) {
    createUnderwriterRate(underwriterRate: $underwriterRate) {
        id
        name
        company {
            id
            name
        }
        rate
        yearOfAddition
    }
}`;

export const edit = gql`mutation EditUnderwriterRate($id: ID!, $underwriterRate: UnderwriterRateInput!) {
    editUnderwriterRate(id: $id, underwriterRate: $underwriterRate) {
        id
        name
        company {
            id
            name
        }
        rate
        yearOfAddition  
    }
}`;


export const remove = gql`mutation RemoveUnderwriterRate($id: ID!) {
    removeUnderwriterRate(id: $id) {
        id
        name
        company {
            id
            name
        }
        rate
        yearOfAddition 
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/underwriterRate.js